/**
 * Stack State
 * @module stackAtoms
 * @category State
 */

import { notify,
	type NavigationTypeType,
	type SDK_Stack,
	clientConfig,
	getSdk,
	strings,
	updateDeprecatedTokens,
} from "@quickpoint.me/shared";
import { getAuth, getIdToken } from "firebase/auth";
import { GraphQLClient } from "graphql-request";
import { atom, atomFamily, selectorFamily } from "recoil";
import { fireUpdateCodeEvent } from "../lib/editor/events";
import { OwnerName } from "./authSelectors";
import { errorStack } from "./stackSelectors";

/**
 * The filename for a stack.
 */

// const setInitialStackCfKey: AtomEffect<string> = ({ setSelf }) => {
//   const stackFromUrl = getStackFromUrl(window.location.pathname);
//   console.log("setInitialStackCfKey", stackFromUrl.stackCfKey);
//   setSelf(stackFromUrl.stackCfKey ? stackFromUrl.stackCfKey : "");
// };

export const StackCfKeyAtom = atom<string>({
	key: "StackCfKey",
	// effects: [setInitialStackCfKey],
});

export const ShowStacks = atom<boolean>({
	key: "ShowStacks",
	default: false,
});

export const ShowStacksDuringDemoMode = atom<boolean>({
	key: "ShowStacksDuringDemoMode",
	default: false,
});

export const ShowShare = atom<boolean>({
	key: "ShowShare",
	default: false,
});

export const CreateNewStack = atom<boolean>({
	key: "CreateNewStack",
	default: false,
});

export const IsCreatingAiStory = atom<boolean>({
	key: "IsCreatingAiStory",
	default: false,
});

const getStackFromBackEnd = selectorFamily<SDK_Stack, string>({
	key: "getCodeSelector",
	get:
		(stackCfKey) =>
		async ({ get }) => {
			const user = getAuth().currentUser;
			if (!user) return errorStack;
			const jwt = await getIdToken(user);
			if (!jwt) return errorStack;
			const ownerName = get(OwnerName);
			if (!ownerName) return errorStack;
			const client = new GraphQLClient(clientConfig.gqlGetStack());
			const sdk = getSdk(client);
			try {
				if (stackCfKey.startsWith(`${ownerName}/${strings.url.helpUrl}`)) {
					stackCfKey = stackCfKey.replace(`${ownerName}/`, "");
				}
				const res = await sdk.GetStack({ ownerName, stackCfKey, jwt });
				if (res.getStack?.__typename === "Stack") {
					if (res.getStack.code) {
						res.getStack.code = updateDeprecatedTokens(res.getStack.code);
					}
					fireUpdateCodeEvent(res.getStack.code, true);
					return res.getStack;
				}
				return errorStack;
			} catch (error) {
				console.error(error);
				notify("There was a problem. Please try again.");
				return errorStack;
			}
		},
});

// param is stackCfKey, ownerName is not required
export const StackAtomFamily = atomFamily<SDK_Stack, string>({
	key: "StackAtomFamily",
	default: getStackFromBackEnd,
});

export const StoryNamesAtom = atom<string[]>({
	key: "StoryNamesAtom",
	default: [],
});

export const NavigationTypeAtom = atom<NavigationTypeType>({
	key: "NavigationTypeAtom",
	default: undefined,
});
